(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-epic-marcas]';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function modulo(value, divisor) {
    if (!divisor) return 0;

    return ((value % divisor) + divisor) % divisor;
  }

  function EpicMarcas(root) {
    this.root = root;
    this.scroller = root.querySelector(
      '[data-epic-marcas-scroller]'
    );
    this.track = root.querySelector(
      '[data-epic-marcas-track]'
    );
    this.group = root.querySelector(
      '[data-epic-marcas-group]'
    );
    this.scrollbar = root.querySelector(
      '[data-epic-marcas-scrollbar]'
    );
    this.thumb = root.querySelector(
      '[data-epic-marcas-scrollbar-thumb]'
    );

    if (!this.scroller || !this.track || !this.group) {
      return;
    }

    this.groupWidth = 0;
    this.offset = 0;
    this.lastFrameTime = 0;

    this.isDraggingTrack = false;
    this.isDraggingScrollbar = false;
    this.isVisible = true;
    this.isDestroyed = false;

    this.isReducedMotion =
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

    this.pointerId = null;
    this.dragStartX = 0;
    this.dragStartOffset = 0;
    this.lastPointerX = 0;
    this.lastPointerTime = 0;
    this.velocity = 0;
    this.inertiaVelocity = 0;

    this.resumeTimer = null;
    this.resumeAt = 0;

    this.autoDuration =
      parseFloat(
        root.getAttribute('data-auto-duration')
      ) || 120;

    this.resumeDelay =
      parseInt(
        root.getAttribute('data-resume-delay'),
        10
      ) || 1500;

    this.boundAnimate = this.animate.bind(this);
    this.boundResize = this.measure.bind(this);

    this.boundPointerDown =
      this.onTrackPointerDown.bind(this);

    this.boundPointerMove =
      this.onPointerMove.bind(this);

    this.boundPointerUp =
      this.onPointerUp.bind(this);

    this.boundWheel =
      this.onWheel.bind(this);

    this.boundScrollbarPointerDown =
      this.onScrollbarPointerDown.bind(this);

    this.boundScrollbarKeyDown =
      this.onScrollbarKeyDown.bind(this);

    this.boundSectionUnload =
      this.onSectionUnload.bind(this);

    this.init();
  }

  EpicMarcas.prototype.init = function () {
    this.measure();
    this.bindEvents();
    this.createObservers();

    this.root.classList.add('is-initialized');

    this.animationFrame =
      window.requestAnimationFrame(
        this.boundAnimate
      );
  };

  EpicMarcas.prototype.bindEvents = function () {
    this.scroller.addEventListener(
      'pointerdown',
      this.boundPointerDown
    );

    this.scroller.addEventListener(
      'wheel',
      this.boundWheel,
      { passive: false }
    );

    window.addEventListener(
      'pointermove',
      this.boundPointerMove,
      { passive: false }
    );

    window.addEventListener(
      'pointerup',
      this.boundPointerUp
    );

    window.addEventListener(
      'pointercancel',
      this.boundPointerUp
    );

    window.addEventListener(
      'resize',
      this.boundResize
    );

    if (this.scrollbar) {
      this.scrollbar.addEventListener(
        'pointerdown',
        this.boundScrollbarPointerDown
      );

      this.scrollbar.addEventListener(
        'keydown',
        this.boundScrollbarKeyDown
      );
    }

    document.addEventListener(
      'shopify:section:unload',
      this.boundSectionUnload
    );
  };

  EpicMarcas.prototype.createObservers = function () {
    var self = this;

    if ('ResizeObserver' in window) {
      this.resizeObserver =
        new ResizeObserver(function () {
          self.measure();
        });

      this.resizeObserver.observe(this.root);
      this.resizeObserver.observe(this.group);
    }

    if ('IntersectionObserver' in window) {
      this.intersectionObserver =
        new IntersectionObserver(
          function (entries) {
            if (!entries.length) return;

            self.isVisible =
              entries[0].isIntersecting;

            if (self.isVisible) {
              self.lastFrameTime =
                performance.now();
            }
          },
          {
            root: null,
            threshold: 0.01
          }
        );

      this.intersectionObserver.observe(
        this.root
      );
    }
  };

  EpicMarcas.prototype.measure = function () {
    if (!this.group) return;

    var newWidth =
      this.group.getBoundingClientRect().width;

    if (!newWidth || newWidth <= 0) return;

    var oldWidth = this.groupWidth;

    var progress = oldWidth
      ? modulo(-this.offset, oldWidth) /
        oldWidth
      : 0;

    this.groupWidth = newWidth;
    this.offset =
      -progress * this.groupWidth;

    this.render();
  };

  EpicMarcas.prototype.getAutoPixelsPerSecond =
    function () {
      if (
        !this.groupWidth ||
        !this.autoDuration
      ) {
        return 0;
      }

      return (
        this.groupWidth /
        this.autoDuration
      );
    };

  EpicMarcas.prototype.pauseAutoplay =
    function () {
      window.clearTimeout(
        this.resumeTimer
      );

      this.resumeAt = Infinity;
    };

  EpicMarcas.prototype.scheduleResume =
    function () {
      var self = this;

      window.clearTimeout(
        this.resumeTimer
      );

      this.resumeAt =
        performance.now() +
        this.resumeDelay;

      this.resumeTimer =
        window.setTimeout(function () {
          self.resumeAt = 0;
          self.lastFrameTime =
            performance.now();
        }, this.resumeDelay);
    };

  EpicMarcas.prototype.isAutoplayPaused =
    function () {
      return (
        this.isReducedMotion ||
        this.isDraggingTrack ||
        this.isDraggingScrollbar ||
        performance.now() <
          this.resumeAt
      );
    };

  /*
    Permite mover el carrusel con:

    - Gesto horizontal del trackpad.
    - Shift + rueda del mouse.

    El desplazamiento vertical normal sigue
    bajando o subiendo la página.
  */
  EpicMarcas.prototype.onWheel =
    function (event) {
      if (!this.groupWidth) return;

      var horizontalDelta = 0;

      var hasHorizontalGesture =
        Math.abs(event.deltaX) >
        Math.abs(event.deltaY);

      if (hasHorizontalGesture) {
        horizontalDelta =
          event.deltaX;
      } else if (
        event.shiftKey &&
        Math.abs(event.deltaY) > 0
      ) {
        horizontalDelta =
          event.deltaY;
      }

      /*
        No detenemos el scroll vertical
        normal de la página.
      */
      if (!horizontalDelta) return;

      event.preventDefault();

      this.inertiaVelocity = 0;

      this.pauseAutoplay();

      this.offset -= horizontalDelta;

      this.normalizeOffset();
      this.render();
      this.scheduleResume();
    };

  EpicMarcas.prototype.onTrackPointerDown =
    function (event) {
      if (
        event.button !== undefined &&
        event.button !== 0
      ) {
        return;
      }

      this.isDraggingTrack = true;
      this.pointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragStartOffset = this.offset;
      this.lastPointerX = event.clientX;

      this.lastPointerTime =
        performance.now();

      this.velocity = 0;
      this.inertiaVelocity = 0;

      this.pauseAutoplay();

      this.scroller.classList.add(
        'is-dragging'
      );

      if (
        this.scroller.setPointerCapture
      ) {
        try {
          this.scroller.setPointerCapture(
            event.pointerId
          );
        } catch (error) {
          /*
            La falta de captura no impide
            que funcione el carrusel.
          */
        }
      }
    };

  EpicMarcas.prototype.onScrollbarPointerDown =
    function (event) {
      if (
        event.button !== undefined &&
        event.button !== 0
      ) {
        return;
      }

      event.preventDefault();

      this.isDraggingScrollbar = true;
      this.pointerId = event.pointerId;
      this.inertiaVelocity = 0;

      this.pauseAutoplay();

      if (this.thumb) {
        this.thumb.classList.add(
          'is-dragging'
        );
      }

      this.updateFromScrollbarPointer(
        event.clientX
      );

      if (
        this.scrollbar.setPointerCapture
      ) {
        try {
          this.scrollbar.setPointerCapture(
            event.pointerId
          );
        } catch (error) {
          /*
            La captura puede no estar
            disponible en ciertos navegadores.
          */
        }
      }
    };

  EpicMarcas.prototype.onPointerMove =
    function (event) {
      if (
        !this.isDraggingTrack &&
        !this.isDraggingScrollbar
      ) {
        return;
      }

      if (
        this.pointerId !== null &&
        event.pointerId !==
          this.pointerId
      ) {
        return;
      }

      if (this.isDraggingScrollbar) {
        event.preventDefault();

        this.updateFromScrollbarPointer(
          event.clientX
        );

        return;
      }

      var deltaX =
        event.clientX -
        this.dragStartX;

      var now = performance.now();

      var elapsed = Math.max(
        now - this.lastPointerTime,
        1
      );

      var pointerDelta =
        event.clientX -
        this.lastPointerX;

      this.offset =
        this.dragStartOffset +
        deltaX;

      this.velocity =
        pointerDelta / elapsed;

      this.lastPointerX =
        event.clientX;

      this.lastPointerTime = now;

      this.normalizeOffset();
      this.render();
    };

  EpicMarcas.prototype.onPointerUp =
    function (event) {
      if (
        !this.isDraggingTrack &&
        !this.isDraggingScrollbar
      ) {
        return;
      }

      if (
        this.pointerId !== null &&
        event.pointerId !==
          this.pointerId
      ) {
        return;
      }

      if (this.isDraggingTrack) {
        this.inertiaVelocity =
          this.velocity * 16;
      }

      this.isDraggingTrack = false;
      this.isDraggingScrollbar = false;
      this.pointerId = null;

      this.scroller.classList.remove(
        'is-dragging'
      );

      if (this.thumb) {
        this.thumb.classList.remove(
          'is-dragging'
        );
      }

      this.scheduleResume();
    };

  EpicMarcas.prototype.updateFromScrollbarPointer =
    function (clientX) {
      if (
        !this.scrollbar ||
        !this.groupWidth
      ) {
        return;
      }

      var rect =
        this.scrollbar.getBoundingClientRect();

      var thumbWidth = this.thumb
        ? this.thumb
            .getBoundingClientRect()
            .width
        : 0;

      var usableWidth = Math.max(
        rect.width - thumbWidth,
        1
      );

      var relativeX =
        clientX -
        rect.left -
        thumbWidth / 2;

      var progress = clamp(
        relativeX / usableWidth,
        0,
        1
      );

      this.offset =
        -progress *
        this.groupWidth;

      this.normalizeOffset();
      this.render();
    };

  EpicMarcas.prototype.onScrollbarKeyDown =
    function (event) {
      if (!this.groupWidth) return;

      var handled = true;

      var step =
        this.groupWidth * 0.05;

      switch (event.key) {
        case 'ArrowLeft':
          this.offset += step;
          break;

        case 'ArrowRight':
          this.offset -= step;
          break;

        case 'PageUp':
          this.offset +=
            this.groupWidth * 0.2;
          break;

        case 'PageDown':
          this.offset -=
            this.groupWidth * 0.2;
          break;

        case 'Home':
          this.offset = 0;
          break;

        case 'End':
          this.offset =
            -this.groupWidth;
          break;

        default:
          handled = false;
      }

      if (!handled) return;

      event.preventDefault();

      this.inertiaVelocity = 0;

      this.pauseAutoplay();
      this.normalizeOffset();
      this.render();
      this.scheduleResume();
    };

  EpicMarcas.prototype.normalizeOffset =
    function () {
      if (!this.groupWidth) return;

      while (
        this.offset <=
        -this.groupWidth
      ) {
        this.offset +=
          this.groupWidth;
      }

      while (this.offset > 0) {
        this.offset -=
          this.groupWidth;
      }
    };

  EpicMarcas.prototype.updateInertia =
    function () {
      if (
        this.isDraggingTrack ||
        this.isDraggingScrollbar
      ) {
        return;
      }

      if (
        Math.abs(
          this.inertiaVelocity
        ) < 0.02
      ) {
        this.inertiaVelocity = 0;
        return;
      }

      this.offset +=
        this.inertiaVelocity;

      this.inertiaVelocity *= 0.94;

      this.normalizeOffset();
    };

  EpicMarcas.prototype.updateAutoplay =
    function (deltaSeconds) {
      if (
        this.isAutoplayPaused() ||
        this.inertiaVelocity !== 0
      ) {
        return;
      }

      var pixelsPerSecond =
        this.getAutoPixelsPerSecond();

      this.offset -=
        pixelsPerSecond *
        deltaSeconds;

      this.normalizeOffset();
    };

  EpicMarcas.prototype.render =
    function () {
      if (!this.track) return;

      this.track.style.transform =
        'translate3d(' +
        this.offset.toFixed(2) +
        'px, 0, 0)';

      this.renderScrollbar();
    };

  EpicMarcas.prototype.renderScrollbar =
    function () {
      if (
        !this.scrollbar ||
        !this.thumb ||
        !this.groupWidth
      ) {
        return;
      }

      var progress =
        modulo(
          -this.offset,
          this.groupWidth
        ) / this.groupWidth;

      var trackWidth =
        this.scrollbar
          .getBoundingClientRect()
          .width;

      var thumbWidth =
        this.thumb
          .getBoundingClientRect()
          .width;

      var usableWidth = Math.max(
        trackWidth - thumbWidth,
        0
      );

      var thumbX =
        progress * usableWidth;

      this.thumb.style.transform =
        'translate3d(' +
        thumbX.toFixed(2) +
        'px, 0, 0)';

      this.scrollbar.setAttribute(
        'aria-valuenow',
        Math.round(
          progress * 100
        )
      );
    };

  EpicMarcas.prototype.animate =
    function (timestamp) {
      if (this.isDestroyed) return;

      if (!this.lastFrameTime) {
        this.lastFrameTime =
          timestamp;
      }

      var deltaMilliseconds =
        Math.min(
          timestamp -
            this.lastFrameTime,
          50
        );

      var deltaSeconds =
        deltaMilliseconds / 1000;

      this.lastFrameTime =
        timestamp;

      if (this.isVisible) {
        this.updateInertia();

        this.updateAutoplay(
          deltaSeconds
        );

        this.render();
      }

      this.animationFrame =
        window.requestAnimationFrame(
          this.boundAnimate
        );
    };

  EpicMarcas.prototype.onSectionUnload =
    function (event) {
      if (
        event &&
        event.target &&
        event.target.contains(
          this.root
        )
      ) {
        this.destroy();
      }
    };

  EpicMarcas.prototype.destroy =
    function () {
      if (this.isDestroyed) return;

      this.isDestroyed = true;

      window.cancelAnimationFrame(
        this.animationFrame
      );

      window.clearTimeout(
        this.resumeTimer
      );

      this.scroller.removeEventListener(
        'pointerdown',
        this.boundPointerDown
      );

      this.scroller.removeEventListener(
        'wheel',
        this.boundWheel
      );

      window.removeEventListener(
        'pointermove',
        this.boundPointerMove
      );

      window.removeEventListener(
        'pointerup',
        this.boundPointerUp
      );

      window.removeEventListener(
        'pointercancel',
        this.boundPointerUp
      );

      window.removeEventListener(
        'resize',
        this.boundResize
      );

      if (this.scrollbar) {
        this.scrollbar.removeEventListener(
          'pointerdown',
          this.boundScrollbarPointerDown
        );

        this.scrollbar.removeEventListener(
          'keydown',
          this.boundScrollbarKeyDown
        );
      }

      document.removeEventListener(
        'shopify:section:unload',
        this.boundSectionUnload
      );

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (
        this.intersectionObserver
      ) {
        this.intersectionObserver.disconnect();
      }

      delete this.root
        .epicMarcasInstance;

      delete this.root.dataset
        .epicMarcasInitialized;
    };

  function initialize(root) {
    if (
      !root ||
      root.dataset
        .epicMarcasInitialized ===
        'true'
    ) {
      return;
    }

    root.dataset
      .epicMarcasInitialized =
      'true';

    root.epicMarcasInstance =
      new EpicMarcas(root);
  }

  function initializeAll(container) {
    var scope = container || document;

    var roots =
      scope.querySelectorAll(
        ROOT_SELECTOR
      );

    for (
      var index = 0;
      index < roots.length;
      index += 1
    ) {
      initialize(roots[index]);
    }
  }

  function onShopifySectionLoad(event) {
    if (
      !event ||
      !event.target
    ) {
      return;
    }

    if (
      event.target.matches &&
      event.target.matches(
        ROOT_SELECTOR
      )
    ) {
      initialize(event.target);
      return;
    }

    initializeAll(event.target);
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeAll(document);
      }
    );
  } else {
    initializeAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    onShopifySectionLoad
  );
})();